import { put, call } from "redux-saga/effects";
import * as types from "../types/actions";
import _ from "lodash";

export function makeRequest(request, returnType) {
  return request()
    .then((response) => response?.[returnType]?.()?.then?.((result) => ({ result, response })))
    .then(({ result, response }) => {
      if (!response.ok) {
        throw result;
      }
      return result;
    });
}

export default function* callApi(request, action, context, returnType = "json") {
  try {
    const response = yield call(makeRequest, request, returnType);
    if (
      (_.has(response, "data.FrontDeskSearchReservation.Error") &&
        response.data.FrontDeskSearchReservation.Error !== null) ||
      _.get(response, "data.FrontDeskSearchReservation.Success", null) == false ||
      _.has(response, "errors[0].message") ||
      _.get(response, "errors[0].message", "") == "500: Internal Server Error" ||
      _.has(response, "error")
    ) {
      yield put({
        type: action + ".ex",
        error: response.data?.FrontDeskSearchReservation?.Error
          ? response.data.FrontDeskSearchReservation.Error
          : response.error,
      });
    } else if (_.get(response, "data.GenericCheckinSearch.Error", null) !== null) {
      yield put({
        type: action + ".ex",
        error: response.data?.GenericCheckinSearch?.Error,
      });
    } else {
      yield put({ type: action + ".ok", response });
    }
    return response;
  } catch (error) {
    yield put({ type: action + ".ex", error: error });
    yield put({
      type: types.CREATE_TOAST,
      payload: { type: "error", message: error.error ? error.error : error },
    });
    throw error;
  }
}

export function* athenaCallApi(request, action) {
  try {
    const response = yield call(request);
    if (response.status == 401) {
      yield put({ type: types.ATHENA_LOGOUT });
      yield put({
        type: types.CREATE_TOAST,
        payload: { type: "error", message: "Your login has expired" },
      });
    } else if (response.ok) {
      const data = yield response.json();
      yield put({ type: action + ".ok", response: data });
    } else {
      const data = yield response.json();
      yield put({ type: action + ".ex", error: data });
    }
  } catch (error) {
    yield put({ type: action + ".ex", error: `Failed to fetch ${action}, check your network` });
    yield put({
      type: types.CREATE_TOAST,
      payload: { type: "error", message: "Fail to fetch" },
    });
    throw error;
  }
}

export function* rentalCallApi(request, action) {
  try {
    const response = yield call(request);
    let data = null;
    try {
      data = yield call([response, "json"]);
    } catch (e) {
      data = null; // handle empty body or invalid JSON
    }

    if (response.status === 401) {
      yield put({
        type: types.CREATE_TOAST,
        payload: { type: "error", message: "Your login has expired" },
      });
      yield put({ type: action + ".ex", error: "Unauthorized" });
    } else if (response.ok) {
      yield put({ type: action + ".ok", response: data });
    } else {
      yield put({ type: action + ".ex", error: data });
    }
    return { response, data }; // return both response and parsed data
  } catch (error) {
    yield put({ type: action + ".ex", error: `Failed to fetch ${action}, check your network` });
    yield put({
      type: types.CREATE_TOAST,
      payload: { type: "error", message: "Fail to fetch" },
    });
    throw error;
  }
}
